import { Cell } from "@m4a3/api-client";
import { API } from "aws-amplify";

export const getAllLandingZonesForCell = async (cells: Cell[]) => {
    let tempZoneArray = [];
    for (let i = 0; i < cells.length; i++) {
        await API.get('orderful-api', `/cells/${cells[i].id}/landing-zones`, {})
        .then(data => {
            tempZoneArray.push(...data.entities);
        })
        .catch(err => console.log(err));
    }
    return tempZoneArray;
}
